import { environment } from '../../../environments/environment.local';

export const currencyUriTemplate = (currencyId?: string): string => {
  return `${environment.API.CURRENCY_URI}/${currencyId}`;
};
